import styled from "styled-components";

export const PanelAdvancedEditorContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  padding: 8px 96px;

  & > div {
    max-width: 600px;
  }
`;
